import {
  RankedTester,
  rankWith,
  schemaMatches
} from "@jsonforms/core";

export const colourRendererTester: RankedTester = rankWith(6,
  schemaMatches(schema => schema.format === "color"));
